let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j8mpg")).then(() => parcelRequire('2vGaw'));